export default __webpack_public_path__ + "static/media/logo16.a3eee85a.png";